export const APPEND_HISTORY_MESSAGE = "APPEND_HISTORY_MESSAGE";
export const CLEAR_HISTORY_MESSAGES = "CLEAR_HISTORY_MESSAGES";
export const HIDE_TIMEOUT_WARNING = "HIDE_TIMEOUT_WARNING";
export const REFRESH_PERSISTED_STATE = "REFRESH_PERSISTED_STATE ";
export const SET_INACTIVITY_TIME = "SET_INACTIVITY_TIME";
export const SET_SESSION_START_TIME = "SET_SESSION_START_TIME";
export const SHOW_TIMEOUT_WARNING = "SHOW_TIMEOUT_WARNING";
export const SET_SESSION_ID = "SET_SESSION_ID";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-end-session/lib/actions/actionTypes.js